import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Invoices } from '../components/invoicing/Invoices';
import { DeliveryNotes } from '../components/invoicing/DeliveryNotes';
import { canAccessInvoicesTab } from '../utils/permissions';

export const Invoicing = () => {
  const { t, language } = useLanguage();
  const { user } = useAuth();
  const showInvoices = canAccessInvoicesTab(user?.role);
  const defaultTab = showInvoices ? 'invoices' : 'delivery-notes';

  return (
    <div className="p-8" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <h1 className="text-4xl font-bold tracking-tight mb-6" lang={language === 'ar' ? 'ar' : 'en'} data-testid="invoicing-title">
        {t('invoicing')}
      </h1>

      <Tabs defaultValue={defaultTab} className="w-full">
        <TabsList className="mb-6" dir="ltr">
          {showInvoices && (
            <TabsTrigger value="invoices" data-testid="tab-invoices">
              <span lang={language === 'ar' ? 'ar' : 'en'}>{t('invoices')}</span>
            </TabsTrigger>
          )}
          <TabsTrigger value="delivery-notes" data-testid="tab-delivery-notes">
            <span lang={language === 'ar' ? 'ar' : 'en'}>{t('deliveryNotes')}</span>
          </TabsTrigger>
        </TabsList>

        {showInvoices && (
          <TabsContent value="invoices">
            <Invoices />
          </TabsContent>
        )}
        <TabsContent value="delivery-notes">
          <DeliveryNotes />
        </TabsContent>
      </Tabs>
    </div>
  );
};